import { Navigate, useLocation, useParams } from "react-router-dom";
import { getModuleHref, moduleRegistry } from "@/modules";
import type { ModuleId } from "@/modules";

export type LegacyParams = Record<string, string | undefined>;

export interface LegacyRedirectSpec {
  from: string;
  moduleId: ModuleId;
  /** Yakalanan params'tan modül segmenti üretir. */
  segment: (params: LegacyParams) => string;
}

/** Eski path'i modül path'ine çevirir; query string ve hash korunur. */
export const LegacyRedirect = ({ spec }: { spec: LegacyRedirectSpec }) => {
  const params = useParams();
  const { search, hash } = useLocation();
  const instance = moduleRegistry.getModuleById(spec.moduleId);

  // Modül kayıtlı değilse (olmamalı) ana sayfaya düş; sessizce 404 vermeyelim
  if (!instance) return <Navigate to="/" replace />;

  return (
    <Navigate
      to={`${getModuleHref(instance, spec.segment(params))}${search}${hash}`}
      replace
    />
  );
};
